import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DamsSelectInputProps } from ".";
import { Avatar, IconButton, Stack, Typography } from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { useState } from "react";
import { DamsColors } from "../styles/DamsColors";

export function ModalItemSelectInput({
  item,
  size = "short",
  items,
  label,
  placeholder,
  handleChange,
  name,
  value,
  error,
  errorMessage,
}: Readonly<DamsSelectInputProps>) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const InputSize =
    size === "long" ? { width: 512, height: 75 } : size==='full' ? {width:'100%',height:75}:  { width: 260, height: 75 };

  const isAvailable = items.find((item) => item.value === value);
  const renderValue = (value: any) => {
    if (!value) {
      return <Typography color="gray">{placeholder}</Typography>;
    }

    if (isAvailable) return isAvailable ? value : "";
  };
  const inputValue = isAvailable ? value : "";
  return (
    <Stack width={'100%'} height={InputSize.height} gap={0.3}>
      <Typography
        fontFamily={"Inter"}
        fontWeight={500}
        fontSize={14}
        color={DamsColors.Text.PageLabel}
      >
        {label}
      </Typography>

      <FormControl>
        <Select
          name={name}
          value={inputValue}
          open={open}
          onChange={handleChange}
          defaultValue=""
          onClose={handleClose}
          displayEmpty
          renderValue={renderValue}
          inputProps={{ "aria-label": "Without label" }}
          IconComponent={CustomEmptyIcon}
          onClick={handleToggle}
          endAdornment={
            <IconButton onClick={handleToggle}>
              <Avatar
                src={DamsAppAsset.icons.select_arrow}
                sx={styles.arrowDownIcon}
              />
            </IconButton>
          }
          sx={styles.selectInput}
        >
          {items.map((data, index) => (
            <MenuItem value={data.value} key={`${index}`}>
              <Typography
                fontFamily={"Inter"}
                fontWeight={400}
                fontSize={16}
                color={"#667085"}
              >
                {data.label}
              </Typography>
            </MenuItem>
          ))}
        </Select>
        {error && (
          <Typography variant="caption" color={"red"} sx={{marginLeft:1}}>
            {errorMessage}
          </Typography>
        )}
      </FormControl>
    </Stack>
  );
}
const CustomEmptyIcon = () => null;

const styles = {
  arrowDownIcon: {
    width: "20px",
    height: "20px",
  },

  selectInput: {
    borderRadius: "8px",
    borderColor: `${DamsColors.Border.PageInput} !important`,

    "& .MuiSelect-select": {
      borderRadius: "8px",
      color: "#667085",
      backgroundColor: "white",

      "&:focus": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },

      "&:hover": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },

      "&:active": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },
      borderColor: `${DamsColors.Border.PageInput} !important`,
    },

    "&.Mui-focused fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
  },
};

export default ModalItemSelectInput;
